import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {put, api, getUser, consts} from '@config';

import Tour, { ReactTourContent } from "../theme/tour";

const user = getUser()

class PosTour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      abc: ""
    };
  }
  onCloseTour() {
    const url = `${api.users.register}${user.id}/`;
    const data = {
      pos_tour: true,
      email: user.email,
      timezone: "America/Belem"
    };
    const payload = resp => {
      window.localStorage.setItem(consts.USER_DATA, JSON.stringify(resp));
    };
    put(url, data, payload);
  }


  UNSAFE_componentWillMount() {}
  render() {
    return (
      <Tour
        badgeVerbose
        onCloseTour={() => this.onCloseTour()}
        steps={[
          {
            selector: "[data-resume]",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent
                title="Resumo da venda"
                goTo={goTo}
                inDOM={inDOM}
                step={step}
              >
                <p>
                  Aqui estão todas as informações da venda.
                    </p>
              </ReactTourContent>
            )
          },
          {
            selector: "[data-methods-payment]",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent
                title="Formas de pagamento"
                goTo={goTo}
                inDOM={inDOM}
                step={step}
              >
                <p>
                  Basta escolhar a forma de pagamento
                    </p>
              </ReactTourContent>
            )
          },
          {
            selector: "[data-list-payments]",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent
                title="Valores pago"
                goTo={goTo}
                inDOM={inDOM}
                step={step}
              >
                <p>
                  Veja todos os valores pagos
                    </p>
              </ReactTourContent>
            )
          },
          {
            selector: "[data-end]",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent
                title="Finalizar venda"
                goTo={goTo}
                inDOM={inDOM}
                step={step}
              >
                <p>
                  Basta clicar em finalizar
                    </p>
                <a className="btn btn-primary btn-block" href="/pos?first-sale=true">Criar Minha primeira venda</a>
              </ReactTourContent>
            )
          }
        ]}
      ></Tour>
    );
  }
  componentWillUnmount() { }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(PosTour);



// WEBPACK FOOTER //
// ./src/components/tours/payment-tour.jsx